<div class="main-container" data-cy="patient-insurance-card-container">
  <div class="insurance-container" data-cy="patient-insurance-card-header">
    <span style="font-weight: 500; color: var(--tdo-primary);" data-cy="patient-insurance-card-title">Patient Insurance Card</span>
    <br /><br />
    <!--<mat-form-field class="insurance-dropdown">
      <mat-label>Select an insurance</mat-label>
      <mat-select (ngModelChange)="insuranceSelected($event)"
                  [(ngModel)]="activeOrganizationId">
        <mat-option *ngFor="let insurance of dataInsurances" [value]="insurance.OrganizationID">
          {{ insurance.Description }}
        </mat-option>
      </mat-select>
    </mat-form-field>!-->
  </div>
  <div style="height:80%; margin-bottom: var(--margin-size); overflow: hidden;" data-cy="patient-insurance-card-content">
    <!--<textarea [readonly]="!selectedParentTreatmentPlan || !selectedTreatmentPlan" style="height: 100%; width: 100%; resize: none; overflow-y: auto; font-size: 12px; background-color: var(&#45;&#45;tdo-background); outline: unset; border: unset; padding: 4px;" rows="5"></textarea>-->
    <app-tdo-simple-note height="100%" style="height:80%;" [numRows]="8" #simpleNote [categoryEnumId]="NoteCategoryEnum.InsuranceCardInfo" [typeEnumId]="NoteTypeEnum.Patient" [PatientId]="this.patientId" parentObjectName="dataPatientInsuranceCard" [objectId]="this.patientId" data-cy="patient-insurance-card-note"></app-tdo-simple-note>
  </div>

  <!--<div *ngIf="dataInsurances && !dataInsurances.length" class="error-container">
    This patient does not have insurance set up. <br />
    Please add an insurance for this patient in the insurance manager.
  </div>

  <div *ngIf="formNotFound" class="error-container">
    No insurance card form was found. <br />
    Please create an insurance card for the patient's insurance organization.
  </div>

  <div class="spinner-container" *ngIf="isLoading">
    <mat-spinner></mat-spinner>
  </div>

  <div *ngIf="activeInsuranceCard && !isLoading && !formNotFound">
    <app-forms-form [CaseWorkItemFormsId]="activeInsuranceCard"></app-forms-form>
  </div>!-->

</div>
